export default {
  View: {
    Delete: 'Delete',
    Edit: 'Edit',
    Empty: 'Select a skill to view its details.',
    InvokeWithPrefix: 'Invoke with',
    InvokeWithSuffix: 'when creating a task',
    Prompt: 'Prompt',
  },
  List: {
    Title: 'Skills',
    Subtitle: 'Agent capabilities',
    NewSkill: '+ Skill',
    Loading: 'Loading skills...',
    Empty: 'No skills found.',
  },
  New: {
    Eyebrow: 'Define the skill',
    Title: 'What should this skill do?',
    SkillNameLabel: 'SKILL NAME - Becomes /SlashCommand',
    SkillNamePlaceholder: 'WelcomeEmail',
    FunctionLabel: 'Select a function',
    SelectPlaceholder: 'Select',
    FunctionOptions: {
      EMAIL: 'Email',
      SMS: 'SMS',
      TEXT: 'Text Gen',
      CAREPLAN: 'Careplan',
      JOB: 'Job Posting',
    },
    InstructionsLabel: 'Add instructions',
    InstructionsPlaceholder:
      'Describe what this email should do, feel free to include specific instructions relating to tone format, style, rules, anything. ' +
      '\n e.g. "Write a warm welcome email to {{client.name}} introducing their new care coordinator {{requester.name}}"',
    GroupLabel: 'Add to group',
    GroupMode: {
      Existing: 'Existing group',
      New: 'Create new',
    },
    NewGroupPlaceholder: 'E.g. Operations',
    Preview: 'Preview',
    Test: 'Test skill',
    Cancel: 'Cancel',
    Create: 'Create skill',
    Edit: 'Edit skill',
  },
};
